import { useSelector } from 'react-redux'

import { selfAccountSelector } from '../../../../../../../../../modules/selectors/selfAccounts'
import { GAM_NETWORK_CODE } from './fields'

export const useIsGamAccountConnectedToRightsHolderAccount = () => {
  const selfAccount = useSelector(selfAccountSelector)

  return selfAccount?.[GAM_NETWORK_CODE]
}
